import React, { createContext, useContext } from 'react';
import { notification } from 'antd';

interface ToastContextData {
  addToast(message: Omit<INotificationProps, 'id'>): void;
}

type NotificationType = 'success' | 'info' | 'warning' | 'error';

interface INotificationProps {
  title: string;
  description: string;
  type: NotificationType;
}

const ToastContext = createContext<ToastContextData>({} as ToastContextData);

interface IToastProvider {
  children: any;
}

const ToastProvider: React.FC<IToastProvider> = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  const addToast = ({ title, description, type }: INotificationProps) => {
    api[type]({
      message: title,
      description,
    });
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      {contextHolder}
      {children}
    </ToastContext.Provider>
  );
};

function useToast(): ToastContextData {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }

  return context;
}

export { ToastProvider, useToast };
